<template>
  <v-container fluid class="principal-body" color="background" style="height: 100%; overflow-y: auto;">
    <v-row>
      <v-col cols="12" class="text-center">
        <img v-if="steps[currentStep].image" :src="steps[currentStep].image">
        <div style="margin-left : 38px; margin-right: 38px; margin-bottom: 20px; margin-top: 7px">
          <h3 style="margin-top: 12px">
            {{ steps[currentStep].description }}
          </h3>
          <h3 v-if="steps[currentStep].additionalDescription" style="margin-top: 12px">
            {{ steps[currentStep].additionalDescription }}
          </h3>
          <h3 v-if="steps[currentStep].additionalDescription2" style="margin-top: 12px">
            {{ steps[currentStep].additionalDescription2 }}
          </h3>
        </div>
        <div v-if="steps[currentStep].video" class="video_style">
          <v-responsive :aspect-ratio="16/9">
            <iframe style="position: absolute;  top: 0;  left: 0;  width: 100%;  height: 100%;" :src="steps[currentStep].video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
          </v-responsive>
        </div>
        <v-col v-if="steps[currentStep].buttons" class="d-flex flex-column align-center">
          <v-btn v-for="(button, index) in steps[currentStep].buttons"
                 v-if="steps[currentStep].buttons"
                 :key="index"
                 class="mr-3"
                 :style="{ ...button.style}"
                 @click="handleStepChange(button.nextStep)">
            {{ button.label }}
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
    name: "Tutorial",
    data () {
        return {
            currentStep: 0,
            popupOpen: true,
            steps: [
                {
                    image: 'logo-big-dark.png',
                    description: this.$t('tutorial.welcomeToByppay'),
                    additionalDescription: this.$t('tutorial.Tell'),
                    buttons: [
                        {
                            label: this.$t('tutorial.discoverbtn'),
                            color: 'primary',
                            nextStep: 1,
                            style: {
                                'background': 'linear-gradient(180deg, #10A4EA 0%, #0AE7C1 100%)',
                                'color': 'white',
                                'margin-top': '5%',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'border-radius': '10px',
                                'white-space': 'pre-line',
                                'width': '70%',
                                'word-wrap': 'break-word',
                                'height': '50px'
                            }
                        },
                        {
                            label: this.$t('tutorial.skipbtn'),
                            color: 'primary',
                            nextStep: -1,
                            style: {
                                'border': '#0AE7C1 solid',
                                'margin-top': '5%',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'border-radius': '10px',
                            }
                        },
                    ]
                },
                {
                    title: 'Paso 2',
                    description: this.$t('tutorial.text1'),
                    additionalDescription: this.$t('tutorial.text2'),
                    video: 'https://www.youtube.com/embed/KoVBcLQEljg',
                    buttons: [
                        {
                            label: this.$t('tutorial.nextbtn'),
                            color: 'error',
                            nextStep: 2,
                            style: {
                                'background': 'linear-gradient(180deg, #10A4EA 0%, #0AE7C1 100%)',
                                'color': 'white',
                                'margin-top': '5%',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'border-radius': '10px',
                            }
                        },
                        {
                            label: this.$t('tutorial.skipbtn'),
                            color: 'primary',
                            nextStep: -1,
                            style: {
                                'border': '#0AE7C1 solid',
                                'margin-top': '5%',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'border-radius': '10px',

                            }
                        },
                    ]
                },
                {
                    title: 'Paso 3',
                    description: this.$t('tutorial.text3'),
                    additionalDescription: this.$t('tutorial.text4'),
                    video: 'https://www.youtube.com/embed/494C02pn1bs',
                    buttons: [
                        {
                            label: this.$t('tutorial.nextbtn'),
                            color: 'error',
                            nextStep: 3,
                            style: {
                                'background': 'linear-gradient(180deg, #10A4EA 0%, #0AE7C1 100%)',
                                'color': 'white',
                                'margin-top': '5%',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'border-radius': '10px',
                            }
                        },
                        {
                            label: this.$t('tutorial.skipbtn'),
                            color: 'primary',
                            nextStep: -1,
                            style: {
                                'border': '#0AE7C1 solid',
                                'margin-top': '5%',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'border-radius': '10px',
                            }
                        },
                    ]
                },
                {
                    title: 'Paso 3',
                    description: this.$t('tutorial.text5'),
                    additionalDescription: this.$t('tutorial.text6'),
                    additionalDescription2: this.$t('tutorial.text65'),

                    buttons: [
                        {
                            label: this.$t('tutorial.paybtn'),
                            color: 'success',
                            nextStep: 4,
                            style: {
                                'background': 'linear-gradient(180deg, #10A4EA 0%, #0AE7C1 100%)',
                                'color': 'white',
                                'margin-top': '5%',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'border-radius': '10px',
                                'word-wrap': 'break-word',
                                'height': '50px'
                            }
                        },
                        {
                            label: this.$t('tutorial.getpaidbtn'),
                            color: 'error',
                            nextStep: 5,
                            style: {
                                'background': 'linear-gradient(180deg, #10A4EA 0%, #0AE7C1 100%)',
                                'color': 'white',
                                'margin-top': '5%',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'border-radius': '10px',
                                'word-wrap': 'break-word',
                                'height': '50px'
                            }
                        }
                    ]
                },
                {
                    title: 'Opción A',
                    description: this.$t('tutorial.text7'),
                    video: 'https://www.youtube.com/embed/aG1cik1Adig',
                    buttons: [
                        {
                            label: this.$t('tutorial.getpaidbtn'),
                            color: 'error',
                            nextStep: 5,
                            style: {
                                'background': 'linear-gradient(180deg, #10A4EA 0%, #0AE7C1 100%)',
                                'color': 'white',
                                'margin-top': '5%',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'border-radius': '10px',
                                'word-wrap': 'break-word',
                                'height': '50px'
                            }
                        },
                        {
                            label: this.$t('tutorial.endtutorial'),
                            color: 'primary',
                            nextStep: -1,
                            style: {
                                'border': '#0AE7C1 solid',
                                'margin-top': '5%',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'border-radius': '10px',
                            }
                        }
                    ]
                },
                {
                    title: 'Opción B',
                    description: this.$t('tutorial.text8'),
                    video: 'https://www.youtube.com/embed/aG1cik1Adig',
                    buttons: [
                        {
                            label: this.$t('tutorial.paybtn'),
                            color: 'success',
                            nextStep: 4,
                            style: {
                                'background': 'linear-gradient(180deg, #10A4EA 0%, #0AE7C1 100%)',
                                'color': 'white',
                                'margin-top': '5%',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'border-radius': '10px',
                                'word-wrap': 'break-word',
                                'height': '50px'
                            }
                        },
                        {
                            label: this.$t('tutorial.endtutorial'),
                            color: 'primary',
                            nextStep: -1,
                            style: {
                                'border': '#0AE7C1 solid',
                                'margin-top': '5%',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'border-radius': '10px',
                            }
                        }
                    ]
                }
            ]
        };
    },
    mounted () {
        if (this.$route.params.color && this.$route.params.message) {
            this.$root.$emit('show-snackbar', {message: this.$route.params.message, color: this.$route.params.color});
        }
    },
    methods: {
        isLogged () {
            console.log('HOLA');
            return false;
        },
        openPopup () {
            this.popupOpen = true;
        },
        closePopup () {
            this.popupOpen = false;
        },
        handleStepChange (nextStep) {
            if (nextStep === -1) {
                if (!this.$user) {
                    this.$router.push({name: 'Login', replace: true});
                } else if (this.$router.history.current.name !== "InvoiceChats") {
                    this.$router.push({name: 'InvoiceChats'});
                }
            } else {
                this.currentStep = nextStep;
            }
        }
    }
};
</script>

  <style scoped>
  .tutorial-container {
    max-width: 800px;
    margin: 0 auto;
  }
  .centered-title {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  /*.video_style{
    position: relative;
    width: 100%;
    padding-bottom: 56.25%; !* 16:9 aspect ratio *!
  }*/

  iframe {
    width: 100%;
    height: 400px;
  }
  </style>

